module.exports = __webpack_public_path__ + "static/media/epiglow-logo.bab6b6d1.jpg";